import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=7afc7f25&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Chat.vue?vue&type=style&index=1&id=7afc7f25&scoped=true&lang=css&"
import style2 from "./Chat.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc7f25",
  null
  
)

export default component.exports